export enum StationFormIDs {
  APP_INTEGRATION = 'APP_INTEGRATION',
  AUTOMATIC_DROPOFF = 'AUTOMATIC_DROPOFF',
  CREATE_STATION = 'CREATE_STATION',
  CUSTOM_DROPOFF = 'CUSTOM_DROPOFF',
  DROPOFF_LOCATION = 'DROPOFF_LOCATION',
  JWO_MANAGE = 'JWO_MANAGE',
  LOADING_AREA = 'LOADING_AREA',
  MANAGE_LOADING_AREAS = 'MANAGE_LOADING_AREAS',
  PAYMENT_EXCLUSIONS_MANAGE = 'PAYMENT_EXCLUSIONS_MANAGE',
  PREORDER_MANAGE = 'PREORDER_MANAGE',
  SCAN_AND_PAY_MANAGE = 'SCAN_AND_PAY_MANAGE',
  STATION_INTEGRATION_AGILYSYS = 'STATION_INTEGRATION_AGILYSYS',
  STATION_INTEGRATION_AGILYSYS_DOD = 'STATION_INTEGRATION_AGILYSYS_DOD',
  STATION_INTEGRATION_MASHGIN = 'STATION_INTEGRATION_MASHGIN',
  STATION_INTEGRATION_NEXTEP = 'STATION_INTEGRATION_NEXTEP',
  STATION_INTEGRATION_VOLANTE = 'STATION_INTEGRATION_VOLANTE',
  STATION_INTEGRATION_CENTRIC_HUB = 'STATION_INTEGRATION_CENTRIC_HUB',
  UPDATE_STATION = 'UPDATE_STATION',
  STATION_INTEGRATION_GRUBHUB = 'STATION_INTEGRATION_GRUBHUB',
  STATION_INTEGRATION_RYST = 'STATION_INTEGRATION_RYST',
  STATION_INTEGRATION_ILLUMIA = 'STATION_INTEGRATION_ILLUMIA',
  STATION_INTEGRATION_AMAZON = 'STATION_INTEGRATION_AMAZON',
}
